import { ModuleModel } from '../../module.model.interface';
import { OrganizationModel } from '../../organization/model/organization.model';
import { FormDescriptor } from '../../form/model/form';

export enum CodeListType {
  Internal,
  DataEntry,
  External,
  Query
}

export class CodeListTypeDetail implements ModuleModel {
  public discriminator = 'CodeListTypeDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const CodeListTypeMap = {
  Internal: new CodeListTypeDetail({ id: 'Internal', name: 'Belső értéklista' }),
  DataEntry: new CodeListTypeDetail({ id: 'DataEntry', name: 'Adatszolgáltatás' }),
  External: new CodeListTypeDetail({ id: 'External', name: 'Külső értéklista' }),
  Query: new CodeListTypeDetail({ id: 'Query', name: 'Lekérdezés' }),
};

export const CodeListTypeList: CodeListTypeDetail[] = [
  CodeListTypeMap.Internal,
  CodeListTypeMap.DataEntry,
  CodeListTypeMap.External,
  CodeListTypeMap.Query,
];

export enum CodeListFilterType {
  None,
  DaylightSavingTime
}

export class CodeListFilterTypeDetail implements ModuleModel {
  public discriminator = 'CodeListFilterTypeDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const CodeListFilterTypeMap = {
  None: new CodeListFilterTypeDetail({ id: 'None', name: 'Nincs' }),
  DaylightSavingTime: new CodeListFilterTypeDetail({ id: 'DaylightSavingTime', name: 'Téli/nyári időszámítás' }),
};

export const CodeListFilterTypeList: CodeListFilterTypeDetail[] = [
  CodeListFilterTypeMap.None,
  CodeListFilterTypeMap.DaylightSavingTime,
];

export enum CodeListDataEntryFilterType {
  None,
  LatestInPeriod,
  LatestInYear,
  Latest,
  NoneWithSameReference,
  LatestInPeriodWithSameReference,
  LatestInYearWithSameReference,
  LatestWithSameReference
}

export class CodeListDataEntryFilterTypeDetail implements ModuleModel {
  public discriminator = 'CodeListDataEntryFilterTypeDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const CodeListDataEntryFilterTypeMap = {
  None: new CodeListDataEntryFilterTypeDetail({ id: 'None', name: 'Nincs' }),
  LatestInPeriod: new CodeListDataEntryFilterTypeDetail({ id: 'LatestInPeriod', name: 'Legfrissebb ugyanazon időszakon belül' }),
  LatestInYear: new CodeListDataEntryFilterTypeDetail({ id: 'LatestInYear', name: 'Legfrissebb ugyanazon éven belül' }),
  Latest: new CodeListDataEntryFilterTypeDetail({ id: 'Latest', name: 'Legfrissebb' }),
  NoneWithSameReference: new CodeListDataEntryFilterTypeDetail({ id: 'NoneWithSameReference', name: 'Nincs, ugyanazon hivatkozással' }),
  LatestInPeriodWithSameReference: new CodeListDataEntryFilterTypeDetail({ id: 'LatestInPeriodWithSameReference', name: 'Legfrissebb ugyanazon időszakon belül, ugyanazon hivatkozással' }),
  LatestInYearWithSameReference: new CodeListDataEntryFilterTypeDetail({ id: 'LatestInYearWithSameReference', name: 'Legfrissebb ugyanazon éven belül, ugyanazon hivatkozással' }),
  LatestWithSameReference: new CodeListDataEntryFilterTypeDetail({ id: 'LatestWithSameReference', name: 'Legfrissebb, ugyanazon hivatkozással' }),
};

export const CodeListDataEntryFilterTypeList: CodeListDataEntryFilterTypeDetail[] = [
  CodeListDataEntryFilterTypeMap.None,
  CodeListDataEntryFilterTypeMap.LatestInPeriod,
  CodeListDataEntryFilterTypeMap.LatestInYear,
  CodeListDataEntryFilterTypeMap.Latest,
  CodeListDataEntryFilterTypeMap.NoneWithSameReference,
  CodeListDataEntryFilterTypeMap.LatestInPeriodWithSameReference,
  CodeListDataEntryFilterTypeMap.LatestInYearWithSameReference,
  CodeListDataEntryFilterTypeMap.LatestWithSameReference,
];

export class CodeListDescriptor implements ModuleModel {
  public discriminator = 'CodeListDescriptor';

  public id: string;
  public name: string;
  public description: string;
  public codeListType: string;
  public codeListFilterType: string;
  public formId: string;
  public organizationId: string;
  public codeListDataEntryFilterType: string;
  public nameField: string;
  public descriptionField: string;
  public organizationMekhCodeField: string;
  public referenceField: string;
  public validFromField: string;
  public validUntilField: string;
  public storedProcedureName: string;

  public organizationDetail: OrganizationModel;
  public organizationName: string;
  public formDetail: FormDescriptor;
  public formName: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;
    name: string;
    description: string;
    codeListType: string;
    codeListFilterType: string;
    formId: string;
    organizationId: string;
    codeListDataEntryFilterType: string;
    nameField: string;
    descriptionField: string;
    organizationMekhCodeField: string;
    referenceField: string;
    validFromField: string;
    validUntilField: string;
    storedProcedureName: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      
      this.name = options.name;
      this.description = options.description;
      this.codeListType = options.codeListType;
      this.codeListFilterType = options.codeListFilterType;
      this.formId = options.formId;
      this.organizationId = options.organizationId;
      this.codeListDataEntryFilterType = options.codeListDataEntryFilterType;
      this.nameField = options.nameField;
      this.descriptionField = options.descriptionField;
      this.organizationMekhCodeField = options.organizationMekhCodeField;
      this.referenceField = options.referenceField;
      this.validFromField = options.validFromField;
      this.validUntilField = options.validUntilField;
      this.storedProcedureName = options.storedProcedureName;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/codelist/model/codelist.ts